import React, { Component } from 'react';
import Parse from 'parse'
import { withRouter } from 'react-router-dom';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { Text, Spinner, GridRow, Heading2, SlightlySlimSection, SlimSection, SelectWrapper, Heading4, Heading3, Heading1, Select, FullWidthWrapper, FullAreaWrapper, PrimaryButton } from './MarketingStyles';
import checkmark from '../../images/icons/checkmark.svg'
import failuremark from '../../images/icons/failuremark.svg'

import { Arrow } from '../../images/icons/Icons';
import MultistepForm from '../../components/onboarding/MultistepForm';

import { inject, observer } from 'mobx-react'

import { trackEvent } from "../../utils/eventTracking"

import spinnerCircle from '../../images/icons/spinner-circle.svg'

import { withCookies, Cookies } from 'react-cookie';

@inject('modalStore', 'utilStore', 'translationStore')
@observer
class LimitedAccessSection extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  checkAccess = ( e ) => {
    e.preventDefault();
    trackEvent( 'Apply - Verfügbarkeit Prüfen', 'Application', 'Click Button' )
    this.props.utilStore.setCheckAvailibility({ region_slug: e.target.region.value})
    setTimeout(() => {
      this.props.history.push("/bewerbung")
    }, 10);
    // this.props.modalStore.setData('check_availibility', { region_slug: e.target.region.value})
    // this.props.modalStore.setState('check_availibility', true)
  }

  checkAvailibility = async () => {
    const { available } = await Parse.Cloud.run("checkRegionAvailibitlity", { region_slug: this.form.state.properties.region }).catch(err => console.error(err))
    if( available ) this.form.selectSub(2)
    else this.form.selectSub(3)
  }

  saveContactDetails = async (e) => {
    const data = e.target
    await Parse.Cloud.run( 'requestMoreInformation', {
      mail: data.mail.value,
      name: data.firstname.value + " " + data.lastname.value,
      companyName: data.company.value,
      phone: data.phone.value,
    })
    const next_week = new Date()
    next_week.setDate(next_week.getDate() + 7)

    const cookies = this.props.cookies;
    cookies.set('application-prefill', {
      region: data.region.value,
      mail: data.mail.value,
      firstname: data.firstname.value,
      lastname: data.lastname.value,
      company: data.company.value,
      phone: data.phone.value,
    }, { path: '/', expires: next_week });



    // save as information request
    // save as cookie (use cookie on appllication to prefill data)
  }

  render() {

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    const { loaded, regions } = this.props.utilStore

    const AvailibilityForm = ({ TrackedSelectField, TrackedTextField, properties, selectSub }) => {

      console.log(properties)
      const validateAndNext = async (e) => {
        selectSub(1)
        await this.saveContactDetails(e)
        this.checkAvailibility()
      }

      return (
        <form onSubmit={e => { e.preventDefault(); validateAndNext(e)} }>
          <TrackedSelectField slug="region" required rerender={true}>
            <option disabled selected hidden key="" value="">{ text('marketing_state') } *</option>
            { regions && regions.map((item, index) => <option key={item.slug} value={item.slug}>{item.title}</option>) }
          </TrackedSelectField>

          { properties.region && 
            <FullWidthWrapper>
              <GridRow
                desktop="1fr 1fr"
                tablet="1fr"
                phone="1fr"
              >
                <TrackedTextField slug="firstname" placeholder={ text('firstname') + ' *' } required />
                <TrackedTextField slug="lastname" placeholder={ text('lastname') + ' *' } required />
              </GridRow>

              <GridRow desktop="1fr">
                <TrackedTextField slug="company" placeholder={ text('company_name') + ' *' } required />
              </GridRow>

              <GridRow desktop="1fr">
                <TrackedTextField slug="phone" placeholder={ text('phone_number') + ' *' } type="tel" required
                  pattern="\+\d{5}\d*"
                  title="Telefonnummer z.B.: +436641234567" />
              </GridRow>

              <GridRow desktop="1fr">
                <TrackedTextField slug="mail" placeholder={ text('email') + ' *' }  type="email" required />
              </GridRow>
            </FullWidthWrapper>
          }

          <FullAreaWrapper style={{ display: 'flex', marginTop: 20 }}>
            <PrimaryButton
              value={ text('limited_form_button') }
              style={{ margin: 'auto 0'}}
            />
          </FullAreaWrapper>
        </form>
      )
    }

    const LoadingAvailibility = () => (
      <div style={{textAlign: 'center'}}>
        <Spinner src={ spinnerCircle } style={{marginTop: 50}} />
      </div>
    )

    const SlotsAvailable = () => (
      <FullWidthWrapper style={{ textAlign: 'left' }}>
        <GridRow desktop="auto 60px" style={{marginTop: 40}}>
          <SlotResultHeading>{ text('limited_form_success') }</SlotResultHeading>
          <SlotResultImage src={ checkmark } />
        </GridRow>

        <PrimaryButton
          value="jetzt bewerben"
          style={{marginTop: 40}}
          onClick={ () => this.props.scrollToCta() }
        />
      </FullWidthWrapper>
    )

    const NoSlotsAvailable = () => (
      <FullWidthWrapper style={{ textAlign: 'left' }}>
        <GridRow desktop="auto 60px" style={{marginTop: 40}}>
          <SlotResultHeading>{ text('limited_form_failed') }</SlotResultHeading>
          <SlotResultImage src={ failuremark } />
        </GridRow>
      </FullWidthWrapper>
    )


    const steps = [
      {
        title: "Verfügbarkeit",
        components: [
          () => <AvailibilityForm />,
          () => <LoadingAvailibility />,
          () => <SlotsAvailable />,
          () => <NoSlotsAvailable />,
        ],
      },
    ]

    return (
      <SlightlySlimSection id="limited-access">
        <GridRow
          desktop="2fr 3fr"
          tablet="1fr"
        >
          <LimitedAccessWrapper>
            <Heading4>{ text('marketing_limited_subheadline') }</Heading4>
            <Heading1>{ text('marketing_limited_headline') }</Heading1>
            <Text>
              { text('marketing_limited_text') }
            </Text>
          </LimitedAccessWrapper>
          <AvailibityWrapper>
            <Heading2>{ text('marketing_limited_form_headline') }</Heading2>
            <Text style={{marginBottom: 20}}>{ text('marketing_limited_form_text') }</Text>

            { loaded && <MultistepForm steps={ steps } onRef={ref =>  { this.form = ref } } /> }
          </AvailibityWrapper>
        </GridRow>
      </SlightlySlimSection>
    )
  }
}

export default withCookies(withRouter(LimitedAccessSection))

const LimitedAccessWrapper = styled(FullWidthWrapper) `
  padding: 50px;

  ${cssVar.breakpoints.phone} {
    padding: 30px;
  }
`

const AvailibityWrapper = styled(LimitedAccessWrapper) `
  background: ${ cssVar.colors.lightest_grey };
`

const SlotResultImage = styled.img`
  max-width: 100%;
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: center;
`

const SlotResultHeading = styled(Heading4)`
  font-weight: bold;
`



// WEBPACK FOOTER //
// /src/components/marketing/LimitedAccessSection.js